import { ApiEndpoint } from "@/app/apiEndpoint";
import { FORMAT_CHANNEL, LANG_EN, LANG_TH } from "@/app/const";
import axios from "@/app/http/axios";
import { ComplaintBuyTicket } from "@/interface/Complaint.interface";
import { TicketChannel } from "@/interface/TicketChannel.interface";

export default class TicketChannelService {
  channels: TicketChannel[] = [];

  constructor() {}

  async getAllMainTicketChannels() {
    const path = ApiEndpoint.TicketChannel.GET_ALL_MAIN;
    try {
      const response = await axios.get<TicketChannel[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      this.channels = response.data;
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  ticketChannelString(
    buyWith: ComplaintBuyTicket,
    lang: string = LANG_TH
  ): string {
    if (this.channels && this.channels.length > 0) {
      const channel = this.channels.find(
        (o) => o.id === buyWith?.mainTicketChannelId
      );
      let text = lang === LANG_EN ? channel?.channelNameEn : channel?.channelNameTh;
      if (channel?.channelOptional) {
        if (channel.formatChannelOptional === FORMAT_CHANNEL.manual) {
          return (text += ` : ${buyWith.remark}`);
        } else if (channel.formatChannelOptional === FORMAT_CHANNEL.option) {
          const sub = channel.ticketChannelSubs?.find(
            (o) => o.id === buyWith.subTicketChannelId
          );
          if (sub)
            return (text += ` : ${
              lang === LANG_EN ? sub?.channelNameEn : sub?.channelNameTh
            }`);
        }
      } else if (text) {
        return text;
      }
    }
    return "-";
  }
}
